var $ = require('jquery');

$(function () {
    $(document).ready(function () {
        var authenticationWrapper = $('.authentication-status');
        var contextId = authenticationWrapper.data('contextId');
        var contextLang = authenticationWrapper.data('contextLang');
        
        if (authenticationWrapper.length && contextId != 'undefined' && contextLang != 'undefined' && !window.SitecoreUtilities.isPageEditor()) {
            $.ajax({
                type: 'GET',
                url: '/api/sitecore/ProfileManagement/loginstatus',
                data: {
                    id: contextId,
                    lang: contextLang
                }
            })
                .done(function (responseHtml) {
                    if (responseHtml != 'undefined' && responseHtml != '') {                        
                        authenticationWrapper.replaceWith(responseHtml);
                    } else {
                        authenticationWrapper.hide();
                    }
                });
        }
    });
});
